export default function Menu() {
    document.addEventListener("DOMContentLoaded", () => {
        toggleDropDown()
        toggleMenu()

        function toggleDropDown() {
            const toggler = document.querySelector('.select-text');
            const options = document.querySelector('.select-menu');

            toggler.addEventListener('click', function () {
                let expanded = this.getAttribute('aria-expanded');

                this.classList.toggle('show');
                options.classList.toggle('show');
                
                if ( expanded == 'false' ) {
                    this.setAttribute('aria-expanded', 'true');
                    options.setAttribute('aria-hidden', 'false');
                } else {
                    this.setAttribute('aria-expanded', 'false');
                    options.setAttribute('aria-hidden', 'true');
                }
            })
        }

        function toggleMenu() {
            const lenis = window.lenis;

            const menu = document.getElementById('menu-open');
            const header = document.getElementById('header');
            const menuWrapper = menu.querySelector('.menu-open__wrapper');
            const toggleBtn = document.querySelector('.menu-toggle');
            const body = document.body;
            let menuTimeline;

            // Create menu timeline
            function createMenuTimeline() {
                menuTimeline = gsap.timeline({
                    paused: true,
                    onReverseComplete: () => {
                        menu.style.visibility = 'hidden';
                    }
                });

                menuTimeline
                    .set(menu, { visibility: 'visible' })
                    .set(menuWrapper, { visibility: 'visible' })
                    // Fade in wrapper
                    .to(menuWrapper, {
                        opacity: 1,
                        duration: 0.3,
                        ease: 'power2.out'
                    })
                    // fade in image
                    .to('.menu-open--img', {
                        opacity: 1,
                        y: 0,
                        duration: 0.8,
                        stagger: 0.05,
                        ease: 'power3.out'
                    }, "-=0.1")
                    // fade in menu items
                    .to('.category-item', {
                        y: 0,
                        duration: 0.8,
                        stagger: 0.05,
                        ease: 'power4.out'
                    }, "-=0.5")
                    // Fade in contact
                    .to('.fade-item', {
                        opacity: 1,
                        y: 0,
                        duration: 0.6,
                        stagger: 0.1,
                        ease: 'power5.out'
                    }, "-=0.5");
            }

            // Initialize timeline
            createMenuTimeline();

            // Toggle menu on navbar-toggler click
            toggleBtn.addEventListener('click', () => {
                const isMenuOpened = body.classList.contains('opened-menu');

                if ( !isMenuOpened ) {
                    body.classList.add('opened-menu');
                    body.style.overflow = 'hidden';
                    
                    menu.style.visibility = 'visible';
                    menuTimeline.play();
                    header.classList.add('bg-blur');

                    lenis.stop();

                } else {
                    body.classList.remove('opened-menu');
                    body.style.overflow = '';
                    
                    menuTimeline.reverse();
                    header.classList.remove('bg-blur');

                    lenis.start();
                }
            });

            // Close menu on escape key press
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && body.classList.contains('opened-menu')) {
                    menuTimeline.reverse();
                    
                    body.classList.remove('opened-menu');
                    body.style.overflow = '';

                    lenis.start();
                }
            });
        }
    })
}